import { SpeakerLoudIcon } from "@radix-ui/react-icons";


export default function SpeakingIndicator({ active }) {
  return (
    <div className="flex items-center gap-2 mt-2 animate-pulse">
      {active && (
        <>
          <SpeakerLoudIcon className="w-4 h-4 text-green-600 animate-bounce" />
          <span className="text-[10px] text-gray-600">Tap to here speech..</span>
        </>
      )}
    </div>
  );
}
